import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Clock from 'react-clock';
import 'react-clock/dist/Clock.css';
import Logo from '../../assets/logo-eabc.png';
import backgroundImage from "../../assets/logo-eabc.png";
import '../../assets/css/Login.css';
import { registerUsers } from '../../api/Auth';
import { useNavigate } from 'react-router-dom';

function RegisterForm(props) {
    const history = useNavigate();
    const [date, setDate] = useState(new Date());
    const [email, setEmail] = useState("");
    const [username, setUsername] = useState("");
    const [password1, setPassword1] = useState("");
    const [password2, setPassword2] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    function handleSubmit(e) {
        e.preventDefault();
        if (!email || !username || !password1 || !password2) {
            return setMessage("All fields are required.");
        }
        if (password1 !== password2) {
            return setMessage("Passwords do not match.");
        }

        setLoading(true);
        let role = "Admin";
        const userData = { email, username, password1, password2, role };
        
        registerUsers(userData, (result) => {
            setLoading(false);
            if (result.ok === 1) {
                setUsername("");
                setEmail("");
                setPassword1("");
                setPassword2("");
                setMessage("User registered successfully!");
                setTimeout(() => history("/login"), 2000);
            } else {
                setMessage("Internal server error occurred. Please check your network.");
            }
        });
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setDate(new Date());
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className='container-fluid' style={{ 
            width: "100%", 
            height: "100vh", 
            display: "flex", 
            justifyContent: "center", 
            alignItems: "center", 
            background: "linear-gradient(135deg, #667eea, #764ba2)",
            animation: "gradient 15s ease infinite", 
            backgroundSize: "400% 400%" 
        }}>
         
             <div className='row justify-content-center' style={{ alignItems: 'center', flex: 1 }}>
                <div className='card' style={{ marginTop: 90, width: 850 }}>
                    <div className='card-body'>
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='clock-container' style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 100, marginTop: 200 }}>
                                <div className='clock-container hidder' style={{backgroundImage: `url(${backgroundImage})`, backgroundSize:340, backgroundRepeat:'no-repeat', display:"flex", justifyContent:"center", alignItems:"center", height:100, marginTop:130}}>
                                    <center> 
                                    <Clock value={date} size={290} /></center>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <center>
                                    <img src={Logo} height={100} alt='Logo' />
                                </center>
                                <center><h4>Register</h4></center>
                                {message && <div className='alert alert-info'>{message}</div>}
                                <form onSubmit={handleSubmit}>
                                    <div className='form-group'>
                                        <label>Email Address</label>
                                        <input type='email' value={email} onChange={(e) => setEmail(e.target.value)} className='form-control' placeholder='Email Address' required />
                                    </div>
                                    <div className='form-group'>
                                        <label>Username</label>
                                        <input type='text' value={username} onChange={(e) => setUsername(e.target.value)} className='form-control' placeholder='Username' required />
                                    </div>
                                    <div className='form-group'>
                                        <label>Password</label>
                                        <input type='password' value={password1} onChange={(e) => setPassword1(e.target.value)} className='form-control' placeholder='Enter Your Password' required />
                                    </div>
                                    <div className='form-group'>
                                        <label>Confirm Password</label>
                                        <input type='password' value={password2} onChange={(e) => setPassword2(e.target.value)} className='form-control' placeholder='Confirm Password' required />
                                    </div>
                                    <div className='form-group'>
                                        <button type='submit' className='btn btn-block btn-success' disabled={loading}>
                                            {loading ? "Registering..." : "Sign Up"}
                                        </button>
                                    </div>
                                    <div className='form-group'>
                                        <p>Already have an account? <Link to="/login">Sign In</Link></p>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    );
}

export default RegisterForm;
